import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import MenuSection from './MenuSection';
import MenuItemSeparator from './MenuItemSeparator';
import Nav from '../../../components/DashboardLayout/Nav/Nav';

import MenuItem from './MenuItem';

import {
  authCurrentUserSelector,
  authCurrentUserTypeSelector
} from '../../../modules/auth/Selectors';
import { updateUserAction } from '../../../modules/users/Actions';
import getLangData from '../../../utils/getLangData';
const langData = getLangData().menu.side;

const MenuList = props => {
  const {
    currentUrl,
    menuConfig,
    layoutConfig,
    userType,
    updateUserType,
    user
  } = props;
  // console.log(menuConfig.aside.items);
  const type =
    user.defaultUserType || localStorage.getItem('defaultType') || userType[0];

  if (type === '0') {
    const superAdminMenu = menuConfig.aside.items.filter(
      item =>
        item.title === langData.dashboard ||
        item.title === langData.users ||
        item.title === langData.training_center ||
        item.title === langData.categories ||
        item.title === langData.job_categories ||
        item.title === langData.tags
      // ||  item.title === 'Settings'
    );
    // console.log(superAdminMenu, "super");
    return superAdminMenu.map((child, index) => {
      return (
        <Nav key={`menuList${index}`}>
          {child.section && <MenuSection item={child} />}
          {child.separator && <MenuItemSeparator item={child} />}
          {child.title && (
            <MenuItem
              item={child}
              currentUrl={currentUrl}
              layoutConfig={layoutConfig}
            />
          )}
        </Nav>
      );
    });
  }

  if (type === '1') {
    const adminMenu = menuConfig.aside.items.filter(
      item =>
        item.title === langData.dashboard ||
        item.title === langData.users ||
        item.title === langData.products ||
        item.title === langData.training_center ||
        item.title === langData.moderation
      //  || item.title === 'Settings'
    );
    // console.log(adminMenu, "admin");
    return adminMenu.map((child, index) => {
      return (
        <Nav key={`menuList${index}`}>
          {child.section && <MenuSection item={child} />}
          {child.separator && <MenuItemSeparator item={child} />}
          {child.title && (
            <MenuItem
              item={child}
              currentUrl={currentUrl}
              layoutConfig={layoutConfig}
            />
          )}
        </Nav>
      );
    });
  }
  if (type === '2') {
    if (userType.length > 1 && userType.includes('2')) {
      const filterUserType = userType.filter(el => el !== '2');
      updateUserType(user._id, { defaultUserType: filterUserType[0] });
    } else if (userType.length === 1 && !userType.includes('2')) {
      // usertype == 0 set default === 0
      // suesrtype == 1 set deault === 1
      if (userType[0] === 0) {
        updateUserType(user._id, { defaultUserType: '0' });
      } else if (userType[0] === 1) {
        updateUserType(user._id, { defaultUserType: '1' });
      }
    } else if (userType.length === 1 && userType.includes('2')) {
      // return menu to create the accounts
      const userMenu = menuConfig.aside.items.filter(item => {
        return item.title === 'Create Profiles';
      });
      return userMenu.map((child, index) => {
        return (
          <Nav key={`menuList${index}`}>
            {child.section && <MenuSection item={child} />}
            {child.separator && <MenuItemSeparator item={child} />}
            {child.title && (
              <MenuItem
                item={child}
                currentUrl={currentUrl}
                layoutConfig={layoutConfig}
              />
            )}
          </Nav>
        );
      });
    }

    // window.location.reload()
  }

  if (type === '3') {
    const artisanMenu = menuConfig.aside.items.filter(item => {
      console.log(item, 'itemitem');
      return (
        item.page === 'dashboard' ||
        item.page === 'my-artisan-products' ||
        item.page === 'my-private-inquiries-artisan' ||
        item.page === 'my-public-inquiries-artisan' ||
        item.page === 'jobs/artisan'
        // || item.title === 'Artisan Jobs'

        //  || item.title === 'Settings'
      );
    });
    artisanMenu.forEach(item => {
      return item.submenu
        ? (item.submenu = item.submenu.filter(
            menu =>
              menu.title === 'Artisans' ||
              menu.title === 'Artisans Tags' ||
              menu.title === 'Artisans Categories'
          ))
        : item;
    });
    // console.log(artisanMenu, "artisan");
    return artisanMenu.map((child, index) => {
      return (
        <Nav key={`menuList${index}`}>
          {child.section && <MenuSection item={child} />}
          {child.separator && <MenuItemSeparator item={child} />}
          {child.title && (
            <MenuItem
              item={child}
              currentUrl={currentUrl}
              layoutConfig={layoutConfig}
            />
          )}
        </Nav>
      );
    });
  }
  if (type === '4') {
    const customerMenu = menuConfig.aside.items.filter(item => {
      return (
        item.title === langData.dashboard ||
        item.page === 'artisan-fav-products' ||
        item.page === 'supplier-fav-products' ||
        item.name === 'Customer Private Inquiries' ||
        item.name === 'Customer Public Inquiries'
        //|| item.title === 'Settings'
      );
    });
    // customerMenu.forEach((item) => {
    // 	return item.submenu
    // 		? (item.submenu = item.submenu.filter(
    // 				(menu) =>
    // 					menu.title === "Artisans" ||
    // 					menu.title === "Artisans Tags" ||
    // 					menu.title === "Artisans Categories"
    // 		  ))
    // 		: item;
    // });
    // console.log(customerMenu, "artisan");
    return customerMenu.map((child, index) => {
      return (
        <Nav key={`menuList${index}`}>
          {child.section && <MenuSection item={child} />}
          {child.separator && <MenuItemSeparator item={child} />}
          {child.title && (
            <MenuItem
              item={child}
              currentUrl={currentUrl}
              layoutConfig={layoutConfig}
            />
          )}
        </Nav>
      );
    });
  }

  if (type === '5') {
    const supplierMenu = menuConfig.aside.items.filter(item => {
      return (
        item.page === 'dashboard' ||
        item.page === 'my-supplier-products' ||
        item.page === 'my-private-inquiries-supplier' ||
        item.page === 'my-public-inquiries-supplier' ||
        item.page === 'jobs/supplier'

        // || item.title === 'Settings'
      );
    });
    supplierMenu.forEach(item => {
      return item.submenu
        ? (item.submenu = item.submenu.filter(
            menu =>
              menu.title === 'Suppliers' ||
              menu.title === 'Suppliers Tags' ||
              menu.title === 'Suppliers Categories'
          ))
        : item;
    });
    // console.log(supplierMenu, "supplier");
    return supplierMenu.map((child, index) => {
      return (
        <Nav key={`menuList${index}`}>
          {child.section && <MenuSection item={child} />}
          {child.separator && <MenuItemSeparator item={child} />}
          {child.title && (
            <MenuItem
              item={child}
              currentUrl={currentUrl}
              layoutConfig={layoutConfig}
            />
          )}
        </Nav>
      );
    });
  }
  if (type === '6') {
    const applicantMenu = menuConfig.aside.items.filter(item => {
      return (
        item.page === 'dashboard' ||
        item.page === 'jobs/my-apply' ||
        item.page === 'jobs/recommendation'
      );
    });
    applicantMenu.forEach(item => {
      return item.submenu
        ? (item.submenu = item.submenu.filter(
            menu =>
              menu.title === 'Suppliers' ||
              menu.title === 'Suppliers Tags' ||
              menu.title === 'Suppliers Categories'
          ))
        : item;
    });
    // console.log(supplierMenu, "supplier");
    return applicantMenu.map((child, index) => {
      return (
        <Nav key={`menuList${index}`}>
          {child.section && <MenuSection item={child} />}
          {child.separator && <MenuItemSeparator item={child} />}
          {child.title && (
            <MenuItem
              item={child}
              currentUrl={currentUrl}
              layoutConfig={layoutConfig}
            />
          )}
        </Nav>
      );
    });
  }
  // return menuConfig.aside.items.map((child, index) => {
  // 	// console.log(child);
  // 	// only show the items that are related to the user
  // 	// always display the dashboard page
  // 	if (userType.indexOf(child.user) < 0 && child.page !== "dashboard")
  // 		return null;
  // 	return (
  // 		<Nav key={`menuList${index}`}>
  // 			{child.section && <MenuSection item={child} />}
  // 			{child.separator && <MenuItemSeparator item={child} />}
  // 			{child.title && (
  // 				<MenuItem
  // 					item={child}
  // 					currentUrl={currentUrl}
  // 					layoutConfig={layoutConfig}
  // 				/>
  // 			)}
  // 		</Nav>
  // 	);
  // });
};

const mapStateToProps = state => ({
  userType: authCurrentUserTypeSelector(state),
  user: authCurrentUserSelector(state)
});
const mapDispatchToProps = {
  updateUserType: updateUserAction
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuList);

// // global

// path="/update-user"
// path="/user-settings"

// // super admin

// path="/users"
// path="/artisans"
// path="/suppliers"
// path="/customers"
// path="/artisan-categories"
// path="/supplier-categories"
// path="/artisan-tags"
// path="/supplier-tags"
// path="/training-center"
// path="/training-center/create"
// path="/training-center/:id"
// path="/training-center/:id/course"
// path="/training-center/:id/course/create"
// path="/training-center/:id/course/:cid"

// // admin
// path="/users"
// path="/artisan-products"
// path="/supplier-products"
// path="/my-supplier-jobs"
// path="/artisans-moderation"
// path="/suppliers-moderation"
// path="/customers-moderation"
// path="/training-center"
// // path="/training-center/create"
// path="/training-center/:id"
// path="/training-center/:id/course"
// path="/training-center/:id/course/create"
// path="/training-center/:id/course/:cid"

// // Artisan

// path="/my-artisan-products"
// path="/my-artisan-followers"
// path="/my-private-inquiries-artisan"
// path="/my-public-inquiries-artisan"

// // supplier

// path="/my-supplier-products"
// path="/my-supplier-followers"
// path="/my-private-inquiries-supplier"
// path="/my-public-inquiries-supplier"

// // customer

// path="/artisan-fav-products"
// path="/supplier-fav-products"
// path="/customer-private-inquiry-artisan"
// path="/customer-private-inquiry-supplier"
// path="/customer-public-inquiry-artisan"
// path="/customer-public-inquiry-supplier"

// // create profiles dashboard

// path="/create-profiles"
